import React from "react";

export default function Title() {
  return (
    <div className="title">
      <h1>Information Transport</h1>
    </div>
  );
}